export default {
  "content": "<g clip-path=\"url(#icon_nav_home_selected_svg__a)\"><path d=\"M15.62 6.532c.24.21.38.51.38.83v7.55c0 .6-.49 1.09-1.09 1.09H1.09c-.6 0-1.09-.49-1.09-1.09v-7.55c0-.32.14-.62.38-.83L7.29.262c.41-.35 1.01-.35 1.42 0l6.91 6.27z\"/></g><defs><clipPath id=\"icon_nav_home_selected_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};